import React, { Component } from 'react';
import { connect } from 'react-redux'
import { Field, FieldArray, reduxForm, propTypes, formValueSelector } from 'redux-form';
import DropdownList from 'react-select';
import { Grid, Radio, RadioGroup, FormControlLabel } from '@material-ui/core';
import TransactionDetails from './TransactionDetails';
import { withStyles } from '@material-ui/core/styles';
import { required, noTransfer, normalizeNumber, normalizePercent, normalizeMax8 } from '../Common/Validation';
import cssClasses from './transaction.css';
import { customStylesSplit200, customStylesSplit450, customStylesSplit350 } from '../UI/select-styles';
import { OptionCustomer, OptionAccount, OptionAccountR1, OptionGst } from '../UI/select';

const styles = theme => ({
  root: {
    flexGrow: 1
  }
});

const ruleOptions = [{ value: "All", label: 'All of these words' }, { value: "Any", label: 'Any of these words' }, { value: "Contains", label: 'Contains' }, { value: "Exact", label: 'This exact wording' }];
const ruleAmountOptions = [{ value: 'LessThan', label: 'Less than' }, { value: 'GreaterThan', label: 'Greater than' }, { value: 'Equal', label: 'Equal to' }];

class SplitTransaction extends Component {

  state = { isFirstLoad: true };

  percentSplit = (input, totalAmount) => (input.value && !isNaN(input.value)) ? (Math.round((input.value / totalAmount * 100) * 10000) / 10000) : '';
  amountSplit = (input, totalAmount) => (input.value && !isNaN(input.value)) ? (Math.round((input.value * totalAmount / 100) * 100) / 100).toFixed(2) : '';
  gstAmount = (amount, gstCode, taxCodes) => {
    if (!gstCode || gstCode.length === []) return 0;
    const gstRate = (typeof gstCode === 'string') ? taxCodes.find(code => code.value === gstCode).rate || 0 : gstCode.rate;
    return (Math.round((amount - (amount / (1 + (gstRate / 100)))) * 100) / 100).toFixed(2);
  };

  renderField = ({ input, label, type, meta: { touched, error } }) => (
    <div>
      <input className={cssClasses.formControl1} {...input} placeholder={label} type={type} />
      {touched && (error && <div className={`${cssClasses.admin_label} text-right ${cssClasses.margin_top_quarter}`}><i className={cssClasses.redBG}>{error}</i></div>)}
    </div>
  );

  renderRuleField = ({ input, label, type, meta: { touched, error } }) => (
    <div className={cssClasses.errorTagRight}>
      <input {...input} className={cssClasses.formControl} placeholder={label} type={type} />
      {touched && (error && <div className={cssClasses.admin_label}><i className={cssClasses.redBG}>{error}</i></div>)}
    </div>
  );

  validate = values => {
    const errors = {};
    if (!values.ruleDescription) {
      errors.ruleDescription = 'Required'
    }

    if ((values.descriptionOperator) && !values.transactionDescription) {
      errors.transactionDescription = 'Required';
    }

    if ((values.amountOperator) && !values.transactionAmount) {
      errors.transactionAmount = 'Required';
    }

    if (!values.descriptionOperator && !values.amountOperator) {
      errors.DislplayErrors = 'A match on description or amount is required';
    }

    return errors;
  }

  renderDropdownList = ({ input, label, rule, change, ...rest, options, meta: { touched, error } }) => {
    input.value = input.value || undefined;

    return (
      <div>
        <DropdownList {...input} {...rest}
          value={options.find(item => item.value === input.value)}
          onChange={(value) => {

            if (value) {
              if (input.name === 'descriptionOperator') change('transactionDescription', rule.trim());
              if (input.name === 'amountOperator') change('transactionAmount', Math.abs(rule));
            } else {
              if (input.name === 'descriptionOperator') change('transactionDescription', '');
              if (input.name === 'amountOperator') change('transactionAmount', '');
            }
            input.onChange((value) ? value.value : null);
          }} onBlur={() => input.change} isClearable openOnFocus={true} placeholder="Anything" />
        {touched && (error && <div className={`${cssClasses.admin_label} text-right ${cssClasses.margin_top_quarter}`}><i className={cssClasses.redBG}>{error}</i></div>)}
      </div>
    )
  };

  renderDropdownSplit = ({ input, defaultVal, options, ...rest }) => {
    input.value = input.value || defaultVal;

    return (
      <div>
        <DropdownList {...input} {...rest} isClearable
          styles={customStylesSplit350}
          components={{ Option: OptionCustomer }}
          menuPlacement="top"
          isOptionDisabled={option => option.isActive === false}
          value={options.find(item => item.value === input.value)}
          onBlur={() => input.change}
          options={options}
          openMenuOnFocus
        />
      </div>
    )
  };

  renderDropdownListAcc = ({ input, ...rest, options, amount, taxCodes, meta: { touched, error }, isR1, isRah }) => (
    <div>
      <DropdownList isClearable {...input} {...rest}
        styles={customStylesSplit450}
        components={(isR1 || isRah) ? { Option: OptionAccountR1 } : { Option: OptionAccount }}
        menuPlacement="top"
        isOptionDisabled={option => option.isActive === false}
        value={options.find(item => item.value === input.value)}
        onChange={(value) => {
          this.props.change(input.name.replace('AccountCode', 'GstCode'), value ? value.defaultTaxCode : null);
          this.props.change(input.name.replace('AccountCode', 'gstAmount'), this.gstAmount(amount, value ? value.defaultTaxCode : null, taxCodes));
          input.onChange(value);
        }}
        onBlur={() => input.change}
        onKeyDown={(e) => {
          const key = e.key;
          const element = e.target;
          if (!isR1 && !isRah && !isNaN(key) && element.value.length === 3 && key !== '/') {
            const accCode = element.value + '/';
            var select_input_field = element.parentElement.querySelector('input[type=text]');
            select_input_field.value = accCode;
          }
        }} />
      {touched && (error && <div className={`${cssClasses.admin_label} text-right ${cssClasses.margin_top_quarter}`}><i className={cssClasses.redBG}>{error}</i></div>)}
    </div>
  );

  renderDropdownListProject = ({ input, ...rest, options, meta: { touched, error } }) => (
    <div>
      <DropdownList
        isClearable {...input} {...rest}
        value={options.find(item => item.value.toUpperCase() === input.value)}
        onBlur={() => input.onBlur()}
        menuPlacement="top"
        styles={customStylesSplit200}
      />
      {touched && (error && <div className={`${cssClasses.admin_label} text-right ${cssClasses.margin_top_quarter}`}><i className={cssClasses.redBG}>{error}</i></div>)}
    </div>
  );

  renderDropdownListGST = ({ input, ...rest, options, amount, meta: { touched, error } }) => (
    <div>
      <DropdownList
        isClearable {...input} {...rest}
        onBlur={() => input.onBlur()}
        value={options.find(item => item.value === input.value)}
        components={{ Option: OptionGst }}
        formatOptionLabel={(option) => option.value}
        menuPlacement="top"
        styles={customStylesSplit450}
        onChange={(value) => {
          let gstAmount = 0;
          if (value)
            gstAmount = (value.rate) ? (Math.round((amount - (amount / (1 + (value.rate / 100)))) * 100) / 100).toFixed(2) : 0;
          this.props.change(input.name.replace('GstCode', 'gstAmount'), gstAmount);
          input.onChange(value);
        }} />
      {touched && (error && <div className={`${cssClasses.admin_label} text-right ${cssClasses.margin_top_quarter}`}><i className={cssClasses.redBG}>{error}</i></div>)}
    </div>
  );

  renderAmount = ({ input, label, type, GstCode, taxCodes, totalAmount, autoFocus, meta: { touched } }) => {
    return (
      <div className={cssClasses.inputWrapper} >
        <span className={cssClasses.inputGroupAddon}>$</span>
        <input className={[cssClasses.formControl1, cssClasses.formControlAmount, cssClasses.fcGroup, cssClasses.fcLeft].join(' ')} autoFocus={autoFocus} {...input} type={type} placeholder={label} onBlur={() => {
          const percent = this.percentSplit(input, totalAmount);
          this.props.change(input.name.replace('Amount', 'Percentage'), percent ? percent.toFixed(2) : '');
          this.props.change(input.name.replace('Amount', 'gstAmount'), this.gstAmount(input.value, GstCode, taxCodes));
        }} />
      </div>
    )
  };

  renderPercent = ({ input, label, type, GstCode, taxCodes, totalAmount }) => (
    <div className={cssClasses.inputWrapper}>
      <input
        className={[cssClasses.formControl1, cssClasses.fcGroup, cssClasses.fcRight].join(' ')}
        {...input}
        type={type}
        placeholder={label}
        value={input.value || ''}
        onChange={(value) => {
          input.onChange(value);
          this.props.change(input.name.replace('Percentage', 'Amount'), this.amountSplit(value.target, totalAmount));
          this.props.change(input.name.replace('Percentage', 'gstAmount'), this.gstAmount(value.target.value * totalAmount / 100, GstCode, taxCodes));
        }} />
      <div className={cssClasses.inputGroupAddon}>%</div>
    </div>
  );

  renderLastField = ({ input, label, type, fields, unallocated, totalAmount, index, meta: { touched, error } }) => (
    <div>
      <input
        className={cssClasses.formControl}
        {...input}
        placeholder={label}
        type={type}
        onBlur={() => {
          if (unallocated === 0 || index < (fields.length - 1)) return null;

          const percentage = (Math.round((unallocated / totalAmount) * 10000000) / 100000) || 0;
          fields.push({ Percentage: percentage.toFixed(2), Amount: (totalAmount * (percentage / 100)).toFixed(2) });
        }} />
      {touched && (error && <div className={`${cssClasses.admin_label} text-right ${cssClasses.margin_top_quarter}`}><i className={cssClasses.redBG}>{error}</i></div>)}
    </div>
  );

  renderType = ({ input, amount, ...rest }) => {
    if (!input.value) { input.onChange((amount > 0) ? "1" : "0") }
    return (
      <RadioGroup style={{ display: 'flex', flexDirection: 'row' }} {...input} {...rest}>
        <FormControlLabel disabled className={cssClasses.width150} value="1" control={<Radio />} label="Money In" />
        <FormControlLabel disabled className={cssClasses.width150} value="0" control={<Radio />} label="Money Out" />
      </RadioGroup>
    )
  };

  renderTransactionRule = (transDetails, change) => {
    return (
      <div className={cssClasses.newCreateRuleContainer}>
        <div className={cssClasses.newCreateRuleRow}>
          <div className={cssClasses.newCreateRuleitem}>
            <label>Create rule:</label>
            <div className={cssClasses.newFlexItem}><Field name="ruleName" type="text" component={this.renderRuleField} validate={required} label="Rule Name" /></div>
            <div className={cssClasses.newFlexItem} />
          </div>
        </div>
        <div className={cssClasses.newCreateRuleRow}>
          <div className={cssClasses.newCreateRuleitem}><label>Type:</label><Field name="typeOperator" type="text" component={this.renderType} amount={transDetails.Amount} /></div>
        </div>
        <div className={cssClasses.newCreateRuleRow}>
          <div className={cssClasses.newCreateRuleitem}>
            <label>Description:</label>
            <div className={cssClasses.newFlexItem}><Field name="descriptionOperator" type="text" component={this.renderDropdownList} options={ruleOptions} rule={transDetails.Description} change={change} /></div>
            <div className={cssClasses.newFlexItem3}><Field name="transactionDescription" type="text" component={this.renderRuleField} label="Rule Description" /></div>
          </div>
        </div>
        <div className={cssClasses.newCreateRuleRow}>
          <div className={cssClasses.newCreateRuleitem}>
            <label>Amount:</label>
            <div className={cssClasses.newFlexItem}><Field name="amountOperator" type="text" component={this.renderDropdownList} options={ruleAmountOptions} rule={transDetails.Amount} change={change} /></div>
            <div className={cssClasses.newFlexItem}><Field name="transactionAmount" type="text" component={this.renderRuleField} label="Rule Amount" normalize={normalizeMax8} /></div>
            <div className={cssClasses.newFlexItem}>&nbsp;</div>
          </div>
        </div>


      </div>


    );
  }
  renderSplit = ({ fields, totalAmount, chart, taxCodes, projects, change, classes, hasGST, taxTracking, splitValues, setUnallocated, meta: { error }, isR1, isRah, isCredit, reset }) => {
    const taxCodeOption = taxCodes.filter(item => (totalAmount > 0 && !isCredit) ? item.isSales : item.isPurchase);
    totalAmount = totalAmount < 0 ? (totalAmount) * -1 : totalAmount;
    const allFields = fields.getAll();
    const tempAmount = allFields ? Math.round((totalAmount - allFields.reduce((sum, value) => {
      sum += value.Amount * 1 || 0;
      return sum;
    }, 0)) * 100) / 100 : 0;
    const unallocated = isNaN(tempAmount) ? totalAmount : tempAmount;
    const percentageTotal = allFields.reduce((percentage, item) => percentage + item.Percentage * 1, 0);
    const isFirstLoad = fields.length === 1 && this.state.isFirstLoad;

    const roundUp = () => {
      if (percentageTotal === 100 && unallocated !== 0 && unallocated !== totalAmount) {
        const lastItem = allFields.slice(-1)[0]
        lastItem.Amount = (lastItem.Amount * 1 + unallocated * 1).toFixed(2);
        fields.remove(allFields.length - 1);
        fields.push(lastItem)
      }
      return;
    }

    const addField = () => {
      this.setState({ isFirstLoad: false }); 
      const percentage = Math.round((unallocated / totalAmount) * 10000000) / 100000 || 0;
      return fields.push({ Percentage: percentage.toFixed(2), Amount: (totalAmount * (percentage / 100)).toFixed(2) });
    }

    const removeLine = (index) => {
      this.setState({ isFirstLoad: false });
      if (index === 0) {
        if (fields.length === 1) reset();
        else fields.shift();
      } else {
        fields.remove(index);
      }
    }

    if (!splitValues) return null;
    if (!isNaN(tempAmount)) setUnallocated(unallocated);
    return (
      <div>
        <table className={[cssClasses.table, cssClasses.tableBordered].join(' ')}>
          <thead>
            <tr>
              <th width="180">Amount</th>
              <th width="100">%</th>
              <th width="80">Qty</th>
              <th width="200">Account</th>
              {(hasGST && taxTracking) && <th width="95">Tax code</th>}
              {(hasGST && taxTracking) && <th width="80">Tax</th>}
              {(projects.length > 0) && <th width="150">Project</th>}
              <th>Description</th>
              <th width="50"><i className="far fa-trash-alt"></i></th>
            </tr>
          </thead>
          <tbody>
            {fields.map((splitTrans, index) =>
              <tr key={index}>
                <td><Field name={`${splitTrans}.Amount`} type="text" component={this.renderAmount} totalAmount={totalAmount} autoFocus={true} taxCodes={taxCodes} GstCode={splitValues ? splitValues[index].GstCode : ''} normalize={normalizeNumber} /></td>
                <td><Field name={`${splitTrans}.Percentage`} type="text" component={this.renderPercent} totalAmount={totalAmount} roundUp={roundUp} taxCodes={taxCodes} GstCode={splitValues ? splitValues[index].GstCode : ''} normalize={normalizePercent} /></td>
                <td><Field name={`${splitTrans}.Quantity`} type="text" component={this.renderField} normalize={normalizeNumber} /></td>
                <td><Field name={`${splitTrans}.AccountCode`} type="text" isR1={isR1} isRah={isRah} component={this.renderDropdownListAcc} options={chart} validate={required} menuStyle={{ backgroundColor: '#ffffdd', height: '110px' }} taxCodes={taxCodes} amount={splitValues ? splitValues[index].Amount : 0} /></td>
                {(hasGST && taxTracking) && <td><Field name={`${splitTrans}.GstCode`} type="text" component={this.renderDropdownListGST} options={taxCodeOption} menuStyle={{ backgroundColor: '#ffffdd', height: '110px' }} amount={splitValues ? splitValues[index].Amount : 0} /></td>}
                {(hasGST && taxTracking) && <td><Field name={`${splitTrans}.gstAmount`} type="text" component={this.renderField} normalize={normalizeNumber} /></td>}
                {(projects.length > 0) && <td><Field name={`${splitTrans}.R1ProjectId`} type="text" component={this.renderDropdownListProject} options={projects} menuStyle={{ backgroundColor: '#ffffdd', height: '110px' }} /></td>}
                <td><Field name={`${splitTrans}.Description`} type="text" component={this.renderLastField} fields={fields} unallocated={unallocated} totalAmount={totalAmount} index={index} /></td>
                <td>{((fields.length > 1) || isFirstLoad) && <div className="top-5" onClick={() => removeLine(index)}><i className="fas fa-times"></i></div>}</td>
              </tr>
            )}
            {isFirstLoad && <tr key={1}>
              <td><Field name={`Coding[${1}].Amount`} type="text" component={this.renderAmount} totalAmount={totalAmount} autoFocus={splitValues[0].Amount} taxCodes={taxCodes} normalize={normalizeNumber} onFocus={addField} /></td>
              <td><Field name={`Coding[${1}].Percentage`} type="text" component={this.renderPercent} totalAmount={totalAmount} roundUp={roundUp} taxCodes={taxCodes} GstCode={''} normalize={normalizePercent} onFocus={addField} /></td>
              <td><Field name={`Coding[${1}].Quantity`} type="text" component={this.renderField} normalize={normalizeNumber} /></td>
              <td><Field name={`Coding[${1}].AccountCode`} type="text" isR1={isR1} isRah={isRah} component={this.renderDropdownListAcc} options={chart} validate={required} menuStyle={{ backgroundColor: '#ffffdd', height: '110px' }} taxCodes={taxCodes} amount={0} /></td>
              {(hasGST && taxTracking) && <td><Field name={`Coding[${1}].GstCode`} type="text" component={this.renderDropdownListGST} options={taxCodeOption} menuStyle={{ backgroundColor: '#ffffdd', height: '110px' }} amount={0} /></td>}
              {(hasGST && taxTracking) && <td><Field name={`Coding[${1}].gstAmount`} type="text" component={this.renderField} normalize={normalizeNumber} /></td>}
              {(projects.length > 0) && <td><Field name={`Coding[${1}].R1ProjectId`} type="text" component={this.renderDropdownListProject} options={projects} menuStyle={{ backgroundColor: '#ffffdd', height: '110px' }} /></td>}
              <td><Field name={`Coding[${1}].Description`} type="text" component={this.renderLastField} fields={fields} unallocated={unallocated} totalAmount={totalAmount} index={1} /></td>
              <td><div className="top-5" onClick={() => this.setState({ isFirstLoad: false })}><i className="fas fa-times"></i></div></td>
            </tr>}
          </tbody>
        </table>
        <Grid container className={classes.root} spacing={8}>
          <Grid item xs={6}>
            <span className={[cssClasses.label, (unallocated !== 0) ? cssClasses.labelWarning : cssClasses.labelSuccess].join(' ')}>Unallocated amount: {unallocated}</span>&nbsp;&nbsp;
                      {error && <span className={[cssClasses.label, cssClasses.labelDanger].join(' ')}>Cannot split a transfer</span>}</Grid>
          <Grid item xs={6} className={cssClasses.textRight}>
            <button type="button" className={[cssClasses.btn, cssClasses.btnXs, cssClasses.btnSecondary].join(' ')} onClick={addField}>Add</button>
          </Grid>
        </Grid>
      </div>
    );
  }

  contactField = (contacts) => (
    <div className={cssClasses.flexContainer}>
      <div className={cssClasses.padding_top_half}>Contact:</div>
      <div className={cssClasses.selectBox}><Field name="contactId" component={this.renderDropdownSplit} options={contacts} /></div>
    </div>
  );

  classificationField = (classification) => (
    <div className={cssClasses.flexContainer}>
      <div className={cssClasses.padding_top_half}>Classification</div>
      <div className={cssClasses.selectBox}><Field name="classificationId" component={this.renderDropdownSplit} options={classification} /></div>
    </div>
  );


  render() {
    const { handleSubmit, accountCodes, change, transDetails, projects, contacts, showRule, toggleRule, classes, classification, hasGST, splitValues, setUnallocated, unallocated, isR1, isRah, taxTracking, isCredit, reset } = this.props;
    const accountChart = accountCodes.chart.filter(item => item.value !== 'split' && item.value !== 'match');
    const contactsOut = [...contacts.filter((item) => (item.isSupplier)),
    ...contacts.filter(item => item.isEmployee),
    ...contacts.filter(item => item.isSuperfund),
    ...contacts.filter(item => item.isOther)];
    const contactsIn = [...contacts.filter((item) => item.isCustomer), ...contacts.filter(item => item.isOther)];
  
    const enableRules = localStorage.getItem("enablerules");

    return (
      <div className={cssClasses.modal_padding}>
        <form onSubmit={handleSubmit} className={cssClasses.formHorizontal}>
          <TransactionDetails modalName={'Split Transaction'} transDetails={transDetails} />
          {(showRule) && this.renderTransactionRule(transDetails, change, classes)}

          <div className={cssClasses.newSplitContainer}>
            <div className={cssClasses.flexWrapper} >
              {Boolean(contacts.length) && this.contactField(transDetails.Amount > 0 ? contactsIn : contactsOut)}
              {Boolean(classification.length) && this.classificationField(classification)}
            </div>
            <div><FieldArray
              name="Coding" component={this.renderSplit}
              chart={accountChart}
              taxCodes={accountCodes.taxCodes}
              projects={projects}
              change={change}
              totalAmount={transDetails.Amount}
              classes={classes}
              classification={classification}
              hasGST={hasGST}
              splitValues={splitValues}
              setUnallocated={setUnallocated}
              validate={noTransfer}
              isR1={isR1}
              isRah={isRah}
              taxTracking={taxTracking}
              isCredit={isCredit}
              reset={reset} /></div>
          </div>

          <div>
            <button type="submit" disabled={unallocated} className={[cssClasses.btn, cssClasses.btnPrimary, cssClasses.btn_margin].join(' ')}>{(showRule) ? 'Save transaction and Rule' : 'Save transaction'}</button>
            {(!isR1 || enableRules) && <button type="button" className={[cssClasses.btn, cssClasses.btnInfo, cssClasses.btn_margin].join(' ')} onClick={() => toggleRule()}>{(showRule) ? 'Hide rule' : 'Create rule'}</button>}
            <button type="button" className={[cssClasses.btn, cssClasses.btnSecondary].join(' ')} onClick={this.props.onClose}>Cancel</button>
          </div>

        </form>
      </div>
    );
  };
}

SplitTransaction.propTypes = {
    ...propTypes
  };


SplitTransaction = reduxForm({
  form: 'splitForm',
})(SplitTransaction)

const selector = formValueSelector('splitForm')
SplitTransaction = connect(state => {
  const splitValues = selector(state, 'Coding')

  return { splitValues };
})(SplitTransaction)

export default withStyles(styles)(SplitTransaction);


// WEBPACK FOOTER //
// ./src/components/Transaction/SplitTransaction.js